import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTenderFoldersFoldersId } from '~src/services/api';
import { DbTenderFolder } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';

interface UseTenderFoldersParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
  root_folder_id?: string;
  folder_id?: string;
  tender_id?: string;
  enabled?: boolean;
}
export const useTenderFoldersFoldersId = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
    root_folder_id,
    folder_id,
    tender_id,
  }: UseTenderFoldersParams = {},
  queryConfig: QueryConfig<DbTenderFolder[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const archiveSettings = useArchiveSettings();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on;

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderSubFoldersQuery = useQuery<DbTenderFolder[], AxiosError>(
    [
      'tenderFoldersFoldersId',
      {
        projectId: String(projectId),
        folder_id,
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
        root_folder_id,
        tender_id,
      },
    ],
    loadTenderFoldersFoldersId,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      // TODO: bad pattern to create reusable hooks with binded logic. These checks is the exact role of controller
      enabled: enabledOverwrite && projectId && isTenderingOn && root_folder_id,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );
  return tenderSubFoldersQuery;
};
